import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Web3Lottery = lazy(() => import('@/pages/Web3/Lottery'))
const Web3Approve = lazy(() => import('@/pages/Web3/Approve'))
const Web3BatchTransfer = lazy(() => import('@/pages/Web3/BatchTransfer'))
const Web3IpfsUpload = lazy(() => import('@/pages/Web3/IpfsUpload'))
const LirenOverview = lazy(() => import('@/pages/Web3/Liren/Overview'))
const LirenAdmin = lazy(() => import('@/pages/Web3/Liren/Admin'))
const LirenCompensation = lazy(() => import('@/pages/Web3/Liren/Compensation'))
const LirenVesting = lazy(() => import('@/pages/Web3/Liren/Vesting'))
const LirenPair = lazy(() => import('@/pages/Web3/Liren/Pair'))

const web3Routes = [
  {
    path: 'web3/lottery',
    element: <Web3Lottery />,
    meta: {
      title: 'Lottery 管理',
      icon: 'WalletOutlined',
      permission: 'web3:lottery:view',
    },
  },
  {
    path: 'web3/approve',
    element: <Web3Approve />,
    meta: {
      title: '代币授权',
      icon: 'SafetyCertificateOutlined',
      permission: 'web3:approve:view',
    },
  },
  {
    path: 'web3/batch-transfer',
    element: <Web3BatchTransfer />,
    meta: {
      title: '批量转移',
      icon: 'SendOutlined',
      permission: 'web3:batch-transfer:view',
    },
  },
  {
    path: 'web3/ipfs-upload',
    element: <Web3IpfsUpload />,
    meta: {
      title: 'IPFS 上传',
      icon: 'CloudUploadOutlined',
      permission: 'web3:ipfs:view',
    },
  },
  {
    path: 'web3/liren',
    element: <Navigate to="/web3/liren/overview" replace />,
    meta: {
      title: 'LIREN',
      icon: 'WalletOutlined',
      permission: 'web3:liren:view',
      hidden: true,
    },
  },
  {
    path: 'web3/liren/overview',
    element: <LirenOverview />,
    meta: {
      title: 'LIREN 合约概览',
      icon: 'WalletOutlined',
      permission: 'web3:liren:overview:view',
    },
  },
  {
    path: 'web3/liren/admin',
    element: <LirenAdmin />,
    meta: {
      title: 'LIREN Owner 管理',
      icon: 'WalletOutlined',
      permission: 'web3:liren:admin:view',
    },
  },
  {
    path: 'web3/liren/compensation',
    element: <LirenCompensation />,
    meta: {
      title: 'LIREN 补偿金库',
      icon: 'WalletOutlined',
      permission: 'web3:liren:compensation:view',
    },
  },
  {
    path: 'web3/liren/vesting',
    element: <LirenVesting />,
    meta: {
      title: 'LIREN 锁仓查询',
      icon: 'WalletOutlined',
      permission: 'web3:liren:vesting:view',
    },
  },
  {
    path: 'web3/liren/pair',
    element: <LirenPair />,
    meta: {
      title: 'LIREN Pair 管理',
      icon: 'WalletOutlined',
      permission: 'web3:liren:pair:view',
    },
  },
]

export default web3Routes
